module["exports"] = [
  "example.org",
  "example.com",
  "example.net"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/internet/example_email.js
// module id = 714
// module chunks = 0